var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.745117,
    y: 0.281738,
    width: 23.569,
    height: 23.569,
    rx: 11.7845,
    fill: "#00ADFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8215 7.94818H15.5795C15.4442 7.94818 15.3282 7.85507 15.2984 7.72331L15.207 7.32101C15.0542 6.6464 14.4639 6.17383 13.7735 6.17383H11.3421C10.6499 6.17383 10.0597 6.64465 9.90858 7.32101L9.81723 7.72331C9.78736 7.85507 9.67142 7.94818 9.53614 7.94818H8.2941C6.97476 7.94818 5.90137 9.02157 5.90137 10.3409V15.5656C5.90137 16.8849 6.97476 17.9583 8.2941 17.9583H16.8233C18.1426 17.9583 19.216 16.8849 19.216 15.5656V10.3409C19.2142 9.02157 18.1409 7.94818 16.8215 7.94818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5299 10.5928C11.3111 10.5928 10.3203 11.5836 10.3203 12.8024C10.3203 14.0212 11.3111 15.012 12.5299 15.012C13.7487 15.012 14.7395 14.0212 14.7395 12.8024C14.7395 11.5836 13.7487 10.5928 12.5299 10.5928ZM12.5299 14.4786C11.6058 14.4786 10.8537 13.7265 10.8537 12.8024C10.8537 11.8783 11.6058 11.1262 12.5299 11.1262C13.454 11.1262 14.2061 11.8783 14.2061 12.8024C14.2061 13.7265 13.454 14.4786 12.5299 14.4786Z",
    fill: "#00ADFE",
    stroke: "#00ADFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCamera);
export default __webpack_public_path__ + "static/media/profile-camera.6e4dbf9a078dd7d239fe4d2baba7a29a.svg";
export { ForwardRef as ReactComponent };